import app from 'flarum/forum/app';
export default function userById(id) {
  var _app$store$getById;
  return (_app$store$getById = app.store.getById('users', String(id))) != null ? _app$store$getById : null;
}
flarum.reg.add('forumaker-arena', 'common/helpers/userById', userById);